import { render, staticRenderFns } from "./updetail.vue?vue&type=template&id=8b696cf6&scoped=true&"
import script from "./updetail.vue?vue&type=script&lang=js&"
export * from "./updetail.vue?vue&type=script&lang=js&"
import style0 from "./updetail.vue?vue&type=style&index=0&id=8b696cf6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b696cf6",
  null
  
)

export default component.exports